// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
  return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/_util/interopDefault.js
// module id = 66
// module chunks = 0